const useStyles = (theme, tabsClasses) => ({
  root: {
    bgcolor: 'transparent',
    width: '100%',
    maxWidth: '1440px',
    overflowX: 'auto',
  },
  tabs: {
    color: '#1F1F1F',
    height: '60px !important',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTabs-scroller': {
      padding: '14px',
      backgroundColor: '#0949EE !important',
    },
    '& .MuiButtonBase-root.MuiTab-textColorPrimary': {
      backgroundColor: '#1b49c4',
      height: '32px !important',
      minHeight: '32px !important',
      color: 'rgba(255, 255, 255, 0.64)',
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      fontWeight: 500,
      height: '32px !important',
      margin: '0 4px!important',
      fontSize: '16px',
      borderRadius: '4px',
      textWrap: 'nowrap',
      maxWidth: 'unset !important',
      minWidth: 'unset !important',
      width: '200px',
      justifyContent: 'space-between',
    },
    '& .MuiTab-root.Mui-selected': {
      background:
        'linear-gradient(to top, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.2) 100%) !important',
      color: '#fff !important',
      margin: '0 4px!important',
      borderRadius: '4px',
      maxWidth: 'unset !important',
      minWidth: 'unset !important',
      maxHeight: 'unset !important',
    },
    [`& .${tabsClasses.scrollButtons}`]: {
      position: 'absolute',
      height: '60px',
      background: '#ECEEF2',
      color: '#1b49c4',
      zIndex: 10,
      '&:first-of-type': {
        left: 0,
      },
      '&:last-of-type': {
        right: 0,
      },
    },
  },
});

export default useStyles;
